/* [EZ] PDP inline buy row + out-of-stock rule. Progressive enhancement over Horizon's native
   buy-buttons block (no core edits).
   1. INLINE ROW: when the [EZ] Buy Now block has the "Inline with Quantity + Add to cart" toggle
      on (data-ez-buynow-inline), group Quantity · Add to Cart · Buy Now on one row; the dynamic
      checkout (Shop Pay) stays below.
   2. OUT OF STOCK: when the native Add to Cart is disabled (sold out / unavailable), hide Buy Now
      entirely and relabel Add to Cart to "Coming Soon" full-width.
   Both re-apply on variant change: Horizon morphs the buy-buttons block on variant select, so we
   watch it with a MutationObserver and rebuild. The observer is disconnected while we mutate to
   avoid feedback loops. If anything is missing, the page keeps Horizon's default layout. */
(function () {
  var COMING_SOON = 'Coming Soon';
  var observer = null;
  var pending = null;

  function getBuyBlock() {
    return document.querySelector('[class*="buy-buttons-block"]:not(.sticky-add-to-cart *)');
  }

  function getAtc(buyblock) {
    return buyblock.querySelector('.add-to-cart-button, button[name="add"]');
  }

  // Set the visible label without destroying Horizon's nested span structure (it lives in the
  // deepest element inside .add-to-cart-text__content).
  function setAtcText(textEl, txt) {
    var node = textEl;
    while (node.firstElementChild) node = node.firstElementChild;
    if (node.textContent.trim() !== txt) node.textContent = txt;
  }

  function hoist(buyblock, atc) {
    var buynow = document.querySelector('.ez-buynow-block[data-ez-buynow-inline]');
    if (!buynow) return;
    var btn = buynow.querySelector('.ez-buynow-block__btn');
    if (!btn) return;                          // OOS → no Buy Now button to hoist
    if (buyblock.querySelector('.ez-buyrow')) return; // already built
    var qty = buyblock.querySelector('.quantity-selector-wrapper, .quantity-selector');
    var row = document.createElement('div');
    row.className = 'ez-buyrow';
    atc.parentNode.insertBefore(row, atc);
    if (qty) row.appendChild(qty);             // Quantity first
    row.appendChild(atc);                      // then Add to Cart
    row.appendChild(btn);                      // then Buy Now
    buynow.classList.add('is-hoisted');        // hide the now-empty original wrapper
    document.documentElement.classList.add('ez-buyrow-ready');
  }

  function applyOOS(buyblock, atc) {
    // Disabled means out of stock — UNLESS it's the transient loading state (ez-pdp-buttons.js),
    // which we must not mistake for OOS or it would flash "Coming Soon" during an add.
    var loading = atc.classList.contains('ez-atc-loading') || atc.getAttribute('aria-busy') === 'true';
    var oos = (atc.disabled || atc.hasAttribute('disabled')) && !loading;
    var textEl = atc.querySelector('.add-to-cart-text__content');
    if (textEl) {
      if (oos) {
        if (atc.dataset.ezOosOrig == null) atc.dataset.ezOosOrig = textEl.textContent.trim();
        setAtcText(textEl, COMING_SOON);
      } else if (atc.dataset.ezOosOrig != null) {
        setAtcText(textEl, atc.dataset.ezOosOrig);
        delete atc.dataset.ezOosOrig;
      }
    }
    // Hide/show the Buy Now button wherever it lives (hoisted into the row, or stacked).
    var bn = document.querySelector('.ez-buynow-block__btn');
    if (bn) bn.style.display = oos ? 'none' : '';
    var row = buyblock.querySelector('.ez-buyrow');
    if (row) row.classList.toggle('ez-oos', oos);
    buyblock.classList.toggle('ez-oos', oos);
  }

  function build() {
    var buyblock = getBuyBlock();
    if (!buyblock) return;
    var atc = getAtc(buyblock);
    if (!atc) return;
    if (observer) observer.disconnect();
    hoist(buyblock, atc);
    applyOOS(buyblock, atc);
    if (observer) observer.observe(buyblock, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  }

  function schedule() { clearTimeout(pending); pending = setTimeout(build, 60); }

  function start() {
    if (!getBuyBlock()) return;
    observer = new MutationObserver(schedule);
    build();
    setTimeout(build, 100);                    // after Horizon hydrates the form
    window.addEventListener('load', build);
    window.addEventListener('pageshow', build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
